import useAuth from '@nobia/zeus-components/lib/auth/useAuth'
import { useChatMessageNotifications } from './useChatMessageNotifications'

/**
 * Subscribes to chat toasts under AccountProvider so navigation uses the live store.
 */
const AppChatNotifications = () => {
  const { status, profile } = useAuth()
  useChatMessageNotifications(status === 'authenticated' && !!profile)
  return null
}

export default AppChatNotifications
